import { PropTypes, Box, CircularProgress } from '@mui/material';

interface Props {
  color?: Exclude<PropTypes.Color, 'default'>;
}

export default function Spinner({ color = 'primary' }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
    >
      <CircularProgress color={color} />
    </Box>
  );
}
